/**************************************************************************************************
 *
 *       @file ./query-param-store.ts
 *
 *       MobX store containing the content of the URL query parameters
 */

/************************************** THIRD-PARTY MODULES ***************************************/
import {observable, action, computed} from 'mobx';
import {observer, inject} from 'mobx-react';

import {parseQueryParams, isTrue} from 'mad-utils/lib/react';

/**************************************** PROJECT MODULES *****************************************/
import {BaseStore} from '../base-store';

/********************************************* EXPORT *********************************************/
/**
 * Store values of query parameters
 */
export class QueryParamStore extends BaseStore {
    public static Instance: QueryParamStore | null = null;

    /***** Query params *****/
    @observable
    platformQueryParam: string | null = null;

    @observable
    emailQueryParam: string | null = null;

    @observable
    codeQueryParam: string | null = null;

    @observable
    fromLoginQueryParam: boolean = false;

    /**
     * Query parameter for requests to Carrot API on signup
     */
    @observable
    carrotTokenQueryParam: string = null;

    /********* INITIALIZATION *********/
    /**
     * Factory method (true constructor)
     * Ensure queryParamStore is singleton
     */
    public static new = (): QueryParamStore => {
        if (!QueryParamStore.Instance) QueryParamStore.Instance = new QueryParamStore();
        return QueryParamStore.Instance;
    };

    /**
     * Grab query params from window
     * envVars must be passed up from their initial location in the entry file
     */
    private constructor() {
        super();
        this._initializeQueryParams();
    }

    /**
     * Extracts query parameters of interest from the URL
     */
    @action
    private _initializeQueryParams() {
        const qp: Record<string, string> = parseQueryParams(window.location.search) || {};

        this.platformQueryParam = qp.platform || null;
        this.emailQueryParam = qp.email || null;
        this.codeQueryParam = qp.code || null;
        this.carrotTokenQueryParam = qp[`carrot-token`] || null;

        this.fromLoginQueryParam = isTrue(qp[`from-login`], true) || null;
    }
}
